module.exports = __webpack_public_path__ + "static/img/3.0a2b6c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/3.png
// module id = dX2r
// module chunks = 0